import { detailsComponents } from './program-details';

export const components: any[] = [
	...detailsComponents,
];

export * from './program-details';
